import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "video-tab" }
const _hoisted_2 = { class: "video-tab__section" }
const _hoisted_3 = {
  key: 0,
  class: "video-tab__block"
}
const _hoisted_4 = { class: "video-tab__line" }
const _hoisted_5 = { class: "video-tab__value video-tab__value--url" }
const _hoisted_6 = { class: "video-tab__line" }
const _hoisted_7 = { class: "video-tab__value" }
const _hoisted_8 = {
  key: 0,
  class: "video-tab__line"
}
const _hoisted_9 = { class: "video-tab__value" }
const _hoisted_10 = {
  key: 1,
  class: "video-tab__line video-tab__line--renditions"
}
const _hoisted_11 = { class: "video-tab__value" }
const _hoisted_12 = {
  key: 2,
  class: "video-tab__line video-tab__line--audios"
}
const _hoisted_13 = { class: "video-tab__value" }
const _hoisted_14 = {
  key: 1,
  class: "video-tab__muted"
}
const _hoisted_15 = { class: "video-tab__section" }
const _hoisted_16 = {
  key: 0,
  class: "video-tab__block"
}
const _hoisted_17 = { class: "video-tab__line" }
const _hoisted_18 = { class: "video-tab__value" }
const _hoisted_19 = { class: "video-tab__line" }
const _hoisted_20 = { class: "video-tab__value" }
const _hoisted_21 = { class: "video-tab__line" }
const _hoisted_22 = { class: "video-tab__value" }
const _hoisted_23 = { class: "video-tab__line" }
const _hoisted_24 = { class: "video-tab__value" }
const _hoisted_25 = { class: "video-tab__line" }
const _hoisted_26 = { class: "video-tab__value" }
const _hoisted_27 = { class: "video-tab__line" }
const _hoisted_28 = { class: "video-tab__value" }
const _hoisted_29 = {
  key: 1,
  class: "video-tab__muted"
}
const _hoisted_30 = { class: "video-tab__section" }
const _hoisted_31 = {
  key: 0,
  class: "video-tab__block"
}
const _hoisted_32 = { class: "video-tab__line" }
const _hoisted_33 = { class: "video-tab__value" }
const _hoisted_34 = { class: "video-tab__line" }
const _hoisted_35 = { class: "video-tab__value" }
const _hoisted_36 = { class: "video-tab__line" }
const _hoisted_37 = { class: "video-tab__value" }
const _hoisted_38 = {
  key: 1,
  class: "video-tab__muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "video-tab__heading" }, "Manifest", -1 /* CACHED */)),
      ($setup.store.manifestUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "video-tab__label" }, "URL", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.trimManifestUrlForDisplay($setup.store.manifestUrl.value)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "video-tab__label" }, "Protocol", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_7, _toDisplayString($setup.store.manifestProtocol.value || '—'), 1 /* TEXT */)
            ]),
            ($setup.store.manifestLabels.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "video-tab__label" }, "Offers", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.manifestLabels.value, (label) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: label,
                        class: "video-tab__pill"
                      }, _toDisplayString(label), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.store.availableRenditions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "video-tab__label" }, "Renditions", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedRenditions, (r, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: r.id || i,
                        class: "video-tab__pill video-tab__pill--rendition"
                      }, _toDisplayString($setup.renditionLabel(r)), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.store.availableAudioTracks.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "video-tab__label" }, "Audios", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.availableAudioTracks.value, (a, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: a.id || i,
                        class: "video-tab__pill video-tab__pill--audio"
                      }, _toDisplayString($setup.audioTrackLabel(a)), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, "No manifest loaded."))
    ]),
    _createElementVNode("section", _hoisted_15, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "video-tab__heading" }, "Playback", -1 /* CACHED */)),
      ($setup.store.playbackInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "video-tab__label" }, "Bitrate", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_18, _toDisplayString($setup.formatBitrate($setup.store.playbackInfo.value.bitrate)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "video-tab__label" }, "Resolution", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_20, _toDisplayString($setup.resolutionText($setup.store.playbackInfo.value)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "video-tab__label" }, "Video codec", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_22, _toDisplayString($setup.store.playbackInfo.value.videoCodec || '—'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "video-tab__label" }, "Audio codec", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_24, _toDisplayString($setup.store.playbackInfo.value.audioCodec || '—'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "video-tab__label" }, "Quality", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_26, _toDisplayString($setup.store.playbackInfo.value.qualityLabel || '—'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "video-tab__label" }, "Playing format", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_28, [
                ($setup.store.playbackInfo.value.dolbyVision)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Dolby Vision")
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.store.playbackInfo.value.hdrType)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString($setup.store.playbackInfo.value.hdrType), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("SDR")
                      ], 64 /* STABLE_FRAGMENT */))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, "No playback info."))
    ]),
    _createElementVNode("section", _hoisted_30, [
      _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "video-tab__heading" }, "Device capabilities", -1 /* CACHED */)),
      ($setup.store.deviceCapabilities.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "video-tab__label" }, "4K / UHD panel", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_33, _toDisplayString($setup.store.deviceCapabilities.value.uhd ? 'Yes' : 'No'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "video-tab__label" }, "HDR", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_35, _toDisplayString($setup.store.deviceCapabilities.value.hdr ? 'Yes' : 'No'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "video-tab__label" }, "Dolby Vision", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_37, _toDisplayString($setup.store.deviceCapabilities.value.dolbyVision ? 'Yes' : 'No'), 1 /* TEXT */)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, "Loading device capabilities…"))
    ])
  ]))
}